import SoldToParty from './sold_to_party.vue';

export default SoldToParty;
